import React from 'react'
import './MembershipUsageTile.css'

export const getMembershipUsagePercent = (
  used: number,
  total: number,
): number => {
  if (total <= 0) return 0
  return Math.min(100, Math.max(0, (used / total) * 100))
}

type MembershipUsageTileProps = {
  label: string
  value: string
  percent: number
}

const MembershipUsageTile: React.FC<MembershipUsageTileProps> = ({
  label,
  value,
  percent,
}) => (
  <div className="membership-usage-tile">
    <p className="membership-usage-tile__label">{label}</p>
    <div className="membership-usage-tile__meter">
      <p className="membership-usage-tile__value">{value}</p>
      <div
        className="membership-usage-tile__track"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(percent)}
      >
        <div
          className="membership-usage-tile__fill"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  </div>
)

export default MembershipUsageTile
